import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { MensagensService } from 'max-ng-lib';
import { Subject } from 'rxjs';
import { AtualizacaoService } from '../../services/atualizacao.service';
import { UsuariosService } from '../../services/usuarios.service';
import { AuthenticationService } from './authentication.service';
import { UserToken } from './user-token';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

	token: any;
	usuarioLogado: any;

	constructor(
		private router: Router,
		private authenticationService: AuthenticationService,
		private mensagensService: MensagensService,
		private usuarioService: UsuariosService,
		private atualizacao: AtualizacaoService
		) {
	}

	canActivate(route: ActivatedRouteSnapshot) {
		const return$ = new Subject<boolean>();
		const tokenQueryParam = route.queryParams.PWE;
		if (tokenQueryParam !== null && tokenQueryParam !== undefined) {
			this.authenticationService.limparSessao();

			this.authenticationService.salvarToken(tokenQueryParam);
			this.authenticationService.salvarUsuarioAutenticado('S');
			this.atualizacao.processar().subscribe(res => console.log(res));

			setTimeout(() => {
				this.usuarioService.getUserToken()
					.subscribe(
						(result) => {
							this.getUserTokenResult(result, return$);
						},
						(error) => {
							if (error.status === 401) {
								this.redirecionePara401(return$);
							} else {
								this.redirecioneParaLogin(return$);
							}
						});
			}, 1000);

		} else {
			setTimeout(() => this.redirecioneParaLogin(return$));
		}

		return return$;
	}

	private getUserTokenResult(userToken: UserToken, return$: Subject<boolean>) {
		this.authenticationService.salvarUsuarioLogado(userToken);
		this.redirecioneParaPaineis(return$);
	}

	redirecioneParaPaineis(return$: Subject<boolean>) {
		return$.next(true);
		this.router.navigate(['/pages']);
	}

	redirecioneParaLogin(return$: Subject<boolean>) {
		return$.next(false);
		this.limparSessao();
		this.router.navigate(['/login']);
	}

	redirecionePara401(return$: Subject<boolean>) {
		return$.next(false);
		this.limparSessao();
		this.router.navigate(['/login/401']);
	}

	private limparSessao() {
		this.authenticationService.limparSessao();
	}
}
